var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgCompaniesLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.1,
    height: 31.184,
    viewBox: "0 0 24.1 31.184"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-companies-link_svg__cls-1,.kpmg-companies-link_svg__cls-7{fill:none}.kpmg-companies-link_svg__cls-1,.kpmg-companies-link_svg__cls-2,.kpmg-companies-link_svg__cls-4{stroke:#fff}.kpmg-companies-link_svg__cls-1,.kpmg-companies-link_svg__cls-2{stroke-linecap:round;stroke-width:1.6px}.kpmg-companies-link_svg__cls-2{fill:#004a9b;stroke-linejoin:round}.kpmg-companies-link_svg__cls-4{fill:#fff}.kpmg-companies-link_svg__cls-6{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-companies-link_svg__ICN_Companii_Active",
    transform: "translate(-303.7 -197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-companies-link_svg__Line_44",
    "data-name": "Line 44",
    className: "kpmg-companies-link_svg__cls-1",
    transform: "translate(304.5 227.382)",
    d: "M22.5 0H0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-companies-link_svg__Group_628",
    "data-name": "Group 628",
    transform: "translate(315 201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-companies-link_svg__Rectangle_159",
    "data-name": "Rectangle 159",
    className: "kpmg-companies-link_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-companies-link_svg__cls-6",
    d: "M4 0h3.143a4 4 0 014 4v20.917H0V4a4 4 0 014-4z",
    transform: "translate(0 1.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-companies-link_svg__cls-7",
    d: "M4 .8h3.143a3.2 3.2 0 013.2 3.2v19.317a.8.8 0 01-.8.8H1.6a.8.8 0 01-.8-.8V4A3.2 3.2 0 014 .8z",
    transform: "translate(0 1.871)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-companies-link_svg__Rectangle_160",
    "data-name": "Rectangle 160",
    className: "kpmg-companies-link_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-companies-link_svg__cls-6",
    d: "M2.786 0a2.786 2.786 0 012.785 2.786v2.273H0V2.786A2.786 2.786 0 012.786 0z",
    transform: "translate(2.786 -2.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-companies-link_svg__cls-7",
    d: "M2.786.8a1.986 1.986 0 011.985 1.986v.977a.5.5 0 01-.5.5H1.3a.5.5 0 01-.5-.5v-.977A1.986 1.986 0 012.786.8z",
    transform: "translate(2.786 -2.376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-companies-link_svg__Rectangle_161",
    "data-name": "Rectangle 161",
    className: "kpmg-companies-link_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-companies-link_svg__cls-6",
    d: "M.929 0a.929.929 0 01.929.929v1.506H0V.929A.929.929 0 01.929 0z",
    transform: "translate(4.643 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-companies-link_svg__cls-7",
    d: "M.929.8a.129.129 0 01.129.129V1.6a.032.032 0 01-.032.032H.832A.032.032 0 01.8 1.6V.929A.129.129 0 01.929.8z",
    transform: "translate(4.643 -4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-companies-link_svg__Line_48",
    "data-name": "Line 48",
    className: "kpmg-companies-link_svg__cls-1",
    transform: "translate(4.179 5.827)",
    d: "M0 0v18.805"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-companies-link_svg__Line_49",
    "data-name": "Line 49",
    className: "kpmg-companies-link_svg__cls-1",
    transform: "translate(6.966 5.827)",
    d: "M0 0v18.805"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-companies-link_svg__Group_622",
    "data-name": "Group 622",
    transform: "translate(312.429 213.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-companies-link_svg__Rectangle_153",
    "data-name": "Rectangle 153",
    className: "kpmg-companies-link_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-companies-link_svg__cls-6",
    d: "M4 0h2.935a4 4 0 014 4v12.389H0V4a4 4 0 014-4z",
    transform: "translate(0 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-companies-link_svg__cls-7",
    d: "M4 .8h2.935a3.2 3.2 0 013.2 3.2v10.789a.8.8 0 01-.8.8H1.6a.8.8 0 01-.8-.8V4A3.2 3.2 0 014 .8z",
    transform: "translate(0 -2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-companies-link_svg__Line_45",
    "data-name": "Line 45",
    className: "kpmg-companies-link_svg__cls-1",
    transform: "translate(3.28 3.148)",
    d: "M0 0h4.374"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-companies-link_svg__Line_46",
    "data-name": "Line 46",
    stroke: "#30acec",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    fill: "none",
    d: "M3.28 6.745h4.374"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-companies-link_svg__Line_47",
    "data-name": "Line 47",
    className: "kpmg-companies-link_svg__cls-1",
    transform: "translate(3.28 10.342)",
    d: "M0 0h4.374"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-companies-link_svg__Group_627",
    "data-name": "Group 627",
    transform: "translate(305.571 207.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-companies-link_svg__Rectangle_157",
    "data-name": "Rectangle 157",
    className: "kpmg-companies-link_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-companies-link_svg__cls-6",
    d: "M4 0h.792a4 4 0 014 4v22.882H0V4a4 4 0 014-4z",
    transform: "translate(0 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-companies-link_svg__cls-7",
    d: "M4 .8h.792a3.2 3.2 0 013.2 3.2v21.282a.8.8 0 01-.8.8H1.6a.8.8 0 01-.8-.8V4A3.2 3.2 0 014 .8z",
    transform: "translate(0 -7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-companies-link_svg__Rectangle_158",
    "data-name": "Rectangle 158",
    className: "kpmg-companies-link_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-companies-link_svg__cls-6",
    d: "M1.884 0a1.884 1.884 0 011.884 1.884v4.85H0v-4.85A1.884 1.884 0 011.884 0z",
    transform: "translate(2.512 13.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-companies-link_svg__cls-7",
    d: "M1.884.8a1.084 1.084 0 011.084 1.084v3.327a.723.723 0 01-.723.723h-.722A.723.723 0 01.8 5.211V1.884A1.084 1.084 0 011.884.8z",
    transform: "translate(2.512 13.149)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-companies-link_svg__Ellipse_168",
    "data-name": "Ellipse 168",
    className: "kpmg-companies-link_svg__cls-4",
    transform: "translate(2.929 7.882)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-companies-link_svg__cls-6",
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-companies-link_svg__cls-7",
    cx: 1.5,
    cy: 1.5,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-companies-link_svg__Ellipse_169",
    "data-name": "Ellipse 169",
    className: "kpmg-companies-link_svg__cls-4",
    transform: "translate(2.929 -2.118)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-companies-link_svg__cls-6",
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-companies-link_svg__cls-7",
    cx: 1.5,
    cy: 1.5,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-companies-link_svg__Path_865",
    "data-name": "Path 865",
    fill: "#30acec"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-companies-link_svg__cls-6",
    d: "M1.5 2.5a1.001 1.001 0 010-2 1.001 1.001 0 010 2z",
    transform: "translate(2.929 2.882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1a.5.5 0 10.001 1.001A.5.5 0 001.5 1m0-1a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    transform: "translate(2.929 2.882)"
  }))))));
}

export default SvgKpmgCompaniesLink;